import { CommonModule } from "@angular/common";
import { Component, ViewEncapsulation } from "@angular/core";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { ICellRendererAngularComp } from "ag-grid-angular";
import { ICellRendererParams } from "ag-grid-community";
import { param } from "jquery";
import { SharedModule } from "../../../../shared.module";
import { FormsModule } from "@angular/forms";
import { NgSelectModule } from "@ng-select/ng-select";
import { DropdownConfig } from "../../../design-system/dropdown/dropdown.modal";

@Component({
    selector: 'ng-select-renderer',
    templateUrl: './ng-select-renderer.component.html',
    styleUrls: ["./ng-select-renderer.component.scss"],
    standalone: true,
    imports: [CommonModule, TranslateModule, SharedModule, FormsModule, NgSelectModule]
})

export class NgSelectRendererComponent implements ICellRendererAngularComp {

    showCheckIcon: boolean;
    placeholder = "";
    items = [];
    value: any;
    params: any;
    dropdownConfig: DropdownConfig = {
        id: 'country',
        label: 'Country',
        placeholder: 'Select a country',
        value: null,
        size: 'sm',
    };

    constructor() { }

    initilize(params: ICellRendererParams) {
        if (params.colDef.headerComponentParams) {
            this.items = params.colDef.headerComponentParams.dropdownItems;
            this.placeholder = params.colDef.headerComponentParams.placeholder;
            this.dropdownConfig = {
                ...this.dropdownConfig,
                placeholder: this.placeholder,
            }
        }
        this.value = params.getValue();
        this.dropdownConfig = {
            ...this.dropdownConfig,
            value: this.value
        }
    }

    agInit(params: any): void {
        this.params = params;
        this.initilize(params);
    }

    refresh(params: any): boolean {
        // AG-Grid reuses this same component instance across different rows (e.g. after
        // the grid's own default-sort re-render right after load, or during scrolling) —
        // agInit only ever fires once per instance, so without updating this.params here
        // too, onChange's this.params.node.data keeps pointing at whichever row this
        // instance was first created for. That silently writes selections onto a stale,
        // detached row object instead of the one actually in the grid's data array, so
        // the row that's really selected in the UI never gets its own field updated —
        // and a save that diffs the real array sees no change and sends nothing.
        this.params = params;
        this.initilize(params);
        return true;
    }

    onChange($event) {
        if (this.params.onChange instanceof Function) {
            const params = {
                event: $event,
                rowData: this.params.node.data
            }
            this.params.onChange(params);
        }
    }
}
